import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PracticalExerciseResubmitButtonContainer = ({
  'data-test-id': dataTestId,
  exerciseName,
  onConfirm
}) => {
  const [showModal, setShowModal] = useState(false);
  const handleClickResubmit = useCallback(() => {
    setShowModal(true);
  }, []);
  const handleClickClose = useCallback(() => {
    setShowModal(false);
  }, []);
  const handleClickConfirm = useCallback(() => {
    onConfirm();
    setShowModal(false);
  }, [onConfirm]);
  const handleClickReject = useCallback(() => {
    setShowModal(false);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showModal && /*#__PURE__*/_jsxs(Modal, {
      "data-test-id": "practical-exercise-resubmit-modal",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.resubmitModal.title",
            options: {
              exerciseName
            }
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: handleClickClose
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.resubmitModal.description"
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "practical-exercise-resubmit-modal-confirm",
          onClick: handleClickConfirm,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.resubmitModal.confirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleClickReject,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.resubmitModal.reject"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": dataTestId,
      onClick: handleClickResubmit,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.resubmit"
      })
    })]
  });
};
export default PracticalExerciseResubmitButtonContainer;